import React from 'react';
import { Box} from '@mui/material';
import ChanceFileListContainer from '../../../containers/chancemng/files/ChanceFileListContainer';
import ChanceMultiFileFormContainer from '../../../containers/chancemng/files/ChanceMultiFileFormContainer';

const ChanceFileTemplate = () => {
  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      <ChanceFileListContainer />
      <ChanceMultiFileFormContainer/>
    </Box>
  );
};

export default ChanceFileTemplate;
